import BreakpointOnly from './BreakpointOnly';
import Collapse from 'bootstrap/js/src/collapse';

export default class CollapseFooterMenus extends BreakpointOnly {
  constructor(breakpoint)
  {
    super(breakpoint);

    this.collapsibleItems = document.querySelectorAll('.footer-collapsible');
    this.collapsibleObjects = [];
    this.onTriggerClick = this.onTriggerClick.bind(this);
    this.onChangeCollapseHandler = this.onChangeCollapseHandler.bind(this);
    this.breakpointChecker();
  }

  breakpointChecker() {
    if( ! this.collapsibleItems ) {
      return false;
    }

    if(this.breakpoint.matches) {
      this.collapsibleItems.forEach( this.collapseInit.bind(this) );
    } else {
      this.collapsibleItems.forEach( this.collapseDestroy.bind(this) );
    }
  }

  collapseInit( item ) {
    const trigger = item.querySelector('.footer__widget-title');
    const target = trigger.nextElementSibling;


    if( ! trigger || ! target ) {
      return;
    }

    CollapseFooterMenus.setCollapsedAttributes(trigger, true);
    trigger.addEventListener('click', this.onTriggerClick);
    target.classList.add('collapse');
    target.addEventListener('shown.bs.collapse', this.onChangeCollapseHandler);
    target.addEventListener('hidden.bs.collapse', this.onChangeCollapseHandler);
    this.collapsibleObjects.push( new  Collapse(target, { parent: '.content-info', toggle: false }));
  }

  collapseDestroy( item ) {
    const trigger = item.querySelector('.footer__widget-title');
    const target = trigger.nextElementSibling;


    if( ! trigger || ! target ) {
      return;
    }

    CollapseFooterMenus.setCollapsedAttributes(trigger, false);
    trigger.removeEventListener('click', this.onTriggerClick);
    target.classList.remove('collapse');
    target.removeEventListener('show.bs.collapse', this.onChangeCollapseHandler);
    target.removeEventListener('hide.bs.collapse', this.onChangeCollapseHandler);
    target.removeAttribute('style');
    this.collapsibleObjects.forEach(item => item.dispose());
  }

  static setCollapsedAttributes( trigger, collapsed = true )
  {
    const action = collapsed ? 'add' : 'remove';
    trigger.setAttribute('aria-expanded', ! collapsed);
    trigger.classList[action]('collapsed');
  }

  onTriggerClick(event) {
    event.preventDefault();
    const trigger = event.target;
    const target = trigger.nextElementSibling;

    if( ! trigger || ! target ) {
      return;
    }

    const collapse = Collapse.getInstance(target);

    if( collapse._isTransitioning ) {
      return;
    }

    if(trigger.classList.contains('collapsed')) {
      collapse.show();
    } else {
      collapse.hide();
    }

  }

  onChangeCollapseHandler( event ) {
    const trigger = event.target.previousElementSibling;
    CollapseFooterMenus.setCollapsedAttributes(trigger, ! trigger.classList.contains('collapsed'));
  }
}
